import { s } from '@/theme/tokens';

export const landingSpacing = {
  sections: {
    stackGap: `calc(${s('3xl')} + ${s('3xl')})`,
    flowStepsTopOffset: s('none'),
  },
  hero: {
    paddingTop: `calc(${s('2xl')} + ${s('md')})`,
    paddingBottom: `calc(${s('xl')} + ${s('lg')})`,
  },
  testingChanged: {
    sectionTitleMarginBottom: s('xl'),
    conclusionTitleMarginBottom: s('none'),
    awarenessToStrugglesGap: s('3xl'),
    strugglesToConclusionGap: s('3xl'),
  },
  earlyAccess: {
    outerPaddingTop: s('2xl'),
    innerPaddingTop: s('2xl'),
    innerPaddingBottom: `calc(${s('2xl')} + ${s('3xl')})`,
    columnsGap: { xs: s('xl'), md: s('xl') },
  },
} as const;
